// from https://stackoverflow.com/questions/79272220/different-results-based-on-browser-when-drawing-an-svg-icon

function setSVGDimensions(text: string): string {
  const defaultWidth = 300;
  const defaultHeight = 150;
  const defaultUnit = '';

  const xml = new DOMParser().parseFromString(text, 'application/xml');
  const svg = xml.getElementsByTagName('svg')[0];

  // extract any width or height values with 2 character units
  const ww = svg?.getAttribute('width');
  const wUnit = ww?.match(/[a-z]{2}$/)?.[0] || defaultUnit;
  let w = Number(ww?.replace(new RegExp(wUnit + '$'), ''));

  const hh = svg?.getAttribute('height');
  const hUnit = hh?.match(/[a-z]{2}$/)?.[0] || defaultUnit;
  let h = Number(hh?.replace(new RegExp(hUnit + '$'), ''));

  // disregard NaN percentage values
  w = w > 0 ? w : 0;
  h = h > 0 ? h : 0;
  const absent = !(w > 0 && h > 0);
  const viewBox = svg
    ?.getAttribute('viewBox')
    ?.split(/[\s,]+?/)
    .map(Number);
  if (viewBox || absent) {
    const wView = viewBox?.[2];
    const hView = viewBox?.[3];
    if (absent && wView > 0 && hView > 0) {
      // calculate missing dimensions based on viewBox aspect ratio and default height
      if (w > 0) {
        h = (w * hView) / wView;
        svg.setAttribute('height', h + wUnit);
      } else if (h > 0) {
        w = (h * wView) / hView;
        svg.setAttribute('width', w + hUnit);
      } else {
        h = defaultHeight;
        w = (h * wView) / hView;
        svg.setAttribute('width', w + defaultUnit);
        svg.setAttribute('height', h + defaultUnit);
      }
    } else {
      // if no valid viewBox use defaults for missing dimensions
      if (w === 0) {
        w = defaultWidth;
        svg.setAttribute('width', w + defaultUnit);
      }
      if (h === 0) {
        h = defaultHeight;
        svg.setAttribute('height', h + defaultUnit);
      }
    }
    svg.setAttribute('preserveAspectRatio', 'none');
    text = new XMLSerializer().serializeToString(xml) || text;
  }
  return text;
}

export async function injectDimensions(src: string): Promise<string> {
  try {
    let blob;
    const response = await fetch(src);
    if (response.headers.get('content-type')?.includes('image/svg+xml')) {
      const text = await response.text();
      blob = new Blob([setSVGDimensions(text)], {type: 'image/svg+xml'});
    } else {
      return src;
    }
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          resolve('');
        }
      };
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    throw new Error(`Error during injection dimensions to route logo: ${e}`);
  }
}
